import { defineField } from 'sanity'

export const buttonThemeFields = [
  defineField({
    name: 'layout',
    title: 'Layout',
    type: 'string',
    options: {
      list: [
        { title: 'Solid', value: 'solid' },
        { title: 'Outline', value: 'outline' },
      ],
      layout: 'radio',
      direction: 'horizontal',
    },
    initialValue: 'solid',
  }),
  defineField({
    name: 'theme',
    title: 'Theme',
    type: 'string',
    options: {
      list: [
        { title: 'Red / White', value: 'brandAlpha' },
        { title: 'Red / Black', value: 'brandBeta' },
        { title: 'Black / White', value: 'betaAlpha' },
        { title: 'Black / Red', value: 'betaBrand' },
        { title: 'White / Black', value: 'alphaBeta' },
        { title: 'White / Red', value: 'alphaBrand' },
      ],
    },
    description: 'Default state / hover state.',
    initialValue: 'brandAlpha',
  }),
  defineField({
    name: 'themeMobile',
    title: 'Theme (mobile)',
    type: 'string',
    options: {
      list: [
        { title: 'Red / White', value: 'brandAlpha' },
        { title: 'Red / Black', value: 'brandBeta' },
        { title: 'Black / White', value: 'betaAlpha' },
        { title: 'Black / Red', value: 'betaBrand' },
        { title: 'White / Black', value: 'alphaBeta' },
        { title: 'White / Red', value: 'alphaBrand' },
      ],
    },
    description: 'Default state / hover state on smaller screens.',
    initialValue: 'brandAlpha',
  }),
]